const intialState = {
    vins: [],
    filterVins: [],
    searchVins: [],
    vinDetails: [],
    vinCountDetails: {},
    vinParkStatus: [],
    vinAgingCount: {}
  };

  
  export const vinsReducer = (state = intialState, { type, payload }) => {
    switch (type) {
      case "LIST_VINS":
        return { ...state, vins: payload };
      case "FILTER_LIST_VINS":
        return { ...state, filterVins: payload };
      case "SEARCH_VINS":
        return { ...state, searchVins: payload };
      case "DETAILS_VINS":
        return { ...state, vinDetails: payload };
      case "VINS_COUNT":
        return { ...state, vinCountDetails: payload };
      case "VINS_PARKED_STATUS":
        return { ...state, vinParkStatus: payload };
      case "VINS_AGING_COUNT":
        return { ...state, vinAgingCount: payload };
      default:
        return state;
    }
  };

